import React, { useEffect, useState } from 'react';
import { Instagram } from 'lucide-react';
import { publicInstagram } from '../lib/api';
import { useT } from '../lib/i18n';

const InstagramFeed = () => {
  const { t } = useT();
  const [data, setData] = useState({ handle: 'chimera_part_2', posts: [] });

  useEffect(() => {
    publicInstagram().then((r) => setData(r.data || {})).catch(() => {});
  }, []);

  const handle = (data.handle || 'chimera_part_2').replace('@', '');
  const profile = `https://www.instagram.com/${handle}/`;
  const posts = (data.posts || []).filter((p) => p && p.image).slice(0, 6);

  return (
    <section className="py-24 px-6 bg-ivory" data-testid="instagram-feed">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="w-3 h-3 rotate-45 bg-gold mx-auto mb-6 border-2 border-dark-crimson"></div>
          <h2 className="text-6xl font-bold text-dark-green mb-6" style={{ fontFamily: 'Playfair Display, serif', letterSpacing: '0.1em' }}>
            {t('instagram.title')}
          </h2>
          <div className="h-1 w-40 bg-dark-crimson mx-auto mt-6 mb-8"></div>
          <p className="text-charcoal text-xl max-w-2xl mx-auto" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            {t('instagram.subtitle')}
          </p>
        </div>

        {posts.length > 0 && (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 mb-12 max-w-5xl mx-auto">
            {posts.map((p, i) => (
              <a
                key={i}
                href={p.url || profile}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`instagram-post-${i}`}
                className="relative aspect-square overflow-hidden border-2 border-gold/30 group hover:border-dark-crimson transition-colors"
              >
                <img
                  src={p.image}
                  alt={`Instagram post ${i + 1}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-dark-green/0 group-hover:bg-dark-green/40 transition-colors flex items-center justify-center">
                  <Instagram className="text-cream opacity-0 group-hover:opacity-100 transition-opacity" size={28} />
                </div>
              </a>
            ))}
          </div>
        )}

        <div className="text-center">
          <a href={profile} target="_blank" rel="noopener noreferrer" data-testid="instagram-follow">
            <button className="inline-flex items-center gap-3 bg-dark-crimson hover:bg-crimson text-cream px-10 py-5 rounded-none border-2 border-gold transition-all duration-300 hover:scale-105 font-semibold tracking-wider">
              <Instagram size={20} />
              {t('instagram.follow')}
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
